import { createAction, props } from '@ngrx/store';
import {RolleItem} from '../../rolle.model';

export const addRolleStart = createAction('MITARBEITERVERWALTUNG::ROLLE_ADD_START', props<{rolle: RolleItem}>());
export const addRolleSucceeded = createAction(
    'MITARBEITERVERWALTUNG::ROLLE_ADD_SUCCEEDED',
    props<{ rolle: RolleItem}>(),
);
export const addRolleFailed = createAction('MITARBEITERVERWALTUNG::ROLLE_ADD_FAILED');
